function OpenSignBoxReducer(state = false, { type, payload }: any) {
  if (payload) {
    return true;
  }
  return false;
}
export default OpenSignBoxReducer;
